export const SET_SORT = "quote_page/SET_SORT";
export const SET_FILTER = "quote_page/SET_FILTER";
export const RESET_FILTER = "quote_page/RESET_FILTER";
export const REFRESH_FILTERS = "quote_page/REFRESH_FILTERS";
export const DENTAL_PLANS_REQUESTED = "quote_page/DENTAL_PLANS_REQUESTED";
export const ALL_DENTAL_PLANS_REQUESTED = "quote_page/ALL_DENTAL_PLANS_REQUESTED";
export const VISION_PLANS_REQUESTED = "quote_page/VISION_PLANS_REQUESTED";
export const LIFE_PLANS_REQUESTED = "quote_page/LIFE_PLANS_REQUESTED";
export const MEC_PLANS_REQUESTED = "quote_page/MEC_PLANS_REQUESTED";
export const MVP_PLANS_REQUESTED = "quote_page/MVP_PLANS_REQUESTED";
export const UPDATE_DENTAL_PLANS = "quote_page/UPDATE_DENTAL_PLANS";
export const UPDATE_ALL_DENTAL_PLANS = "quote_page/UPDATE_ALL_DENTAL_PLANS";
export const UPDATE_VISION_PLANS = "quote_page/UPDATE_VISION_PLANS";
export const UPDATE_LIFE_PLANS = "quote_page/UPDATE_LIFE_PLANS";
export const UPDATE_MEC_PLANS = "quote_page/UPDATE_MEC_PLANS";
export const UPDATE_MVP_PLANS = "quote_page/UPDATE_MVP_PLANS";
export const PLAN_SUITE_REQUESTED = "quote_page/PLAN_SUITE_REQUESTED";
export const COMPANY_PROFILE_REQUESTED = "quote_page/COMPANY_PROFILE_REQUESTED";
export const EMPLOYEE_PROFILE_REQUESTED = "quote_page/EMPLOYEE_PROFILE_REQUESTED";
export const EMPLOYEE_SYNC_REQUESTED = "quote_page/EMPLOYEE_SYNC_REQUESTED";
export const INITIAL_STATE_LOAD_REQUESTED = "quote_page/INITIAL_STATE_LOAD_REQUESTED";
export const INITIAL_STATE_LOAD_FINISHED = "quote_page/INITIAL_STATE_LOAD_FINISHED";
export const INITIAL_STATE_LOAD_SUCCESS = "quote_page/INITIAL_STATE_LOAD_SUCCESS";
export const SHOW_EXTRA_PLANS = "quote_page/SHOW_EXTRA_PLANS";
export const HIDE_EXTRA_PLANS = "quote_page/HIDE_EXTRA_PLANS";
export const START_APPLICATION = "quote_page/START_APPLICATION";
export const RECOMMENDATION_SURVEY_LOADED = "quote_page/RECOMMENDATION_SURVEY_LOADED";
export const UPDATE_RECOMMENDED_PLANS = "quote_page/UPDATE_RECOMMENDED_PLANS";

export const UPDATE_CART_PLANS = "shopping_cart/UPDATE_CART_PLANS";
export const UPDATE_EMPLOYEE_PROFILE = "shopping_cart/UPDATE_EMPLOYEE_PROFILE";
export const UPDATE_COMPANY_PROFILE = "shopping_cart/UPDATE_COMPANY_PROFILE";

export const REFRESH_QUOTE = "quote_page/REFRESH_QUOTE";

export function requestPlanSuite() {
  return { type: PLAN_SUITE_REQUESTED };
}

export function requestInitialData() {
  return { type: INITIAL_STATE_LOAD_REQUESTED };
}

export function requestDentalPlans(payloadConfig) {
  const { companyIdToken } = payloadConfig || {};
  return {
    type: DENTAL_PLANS_REQUESTED,
    ...(payloadConfig
      ? {
          companyIdToken,
        }
      : {}),
  };
}

export function requestAllDentalPlans() {
  return { type: ALL_DENTAL_PLANS_REQUESTED };
}

export function requestVisionPlans(payloadConfig) {
  const { companyIdToken } = payloadConfig || {};
  return {
    type: VISION_PLANS_REQUESTED,
    ...(payloadConfig
      ? {
          companyIdToken,
        }
      : {}),
  };
}

export function requestLifePlans(payloadConfig) {
  const { companyIdToken } = payloadConfig || {};
  return {
    type: LIFE_PLANS_REQUESTED,
    ...(payloadConfig
      ? {
          companyIdToken,
        }
      : {}),
  };
}

export function requestMecPlans(payloadConfig) {
  const { companyIdToken } = payloadConfig || {};
  return {
    type: MEC_PLANS_REQUESTED,
    ...(payloadConfig
      ? {
          companyIdToken,
        }
      : {}),
  };
}

export function requestMvpPlans(payloadConfig) {
  const { companyIdToken } = payloadConfig || {};
  return {
    type: MVP_PLANS_REQUESTED,
    ...(payloadConfig
      ? {
          companyIdToken,
        }
      : {}),
  };
}

export function setSort(sort) {
  return {
    type: SET_SORT,
    sort,
    meta: {
      analytics: {
        type: "sort_selected",
        properties: {
          value: sort,
          deprecatedName: "select-sort",
          deprecatedLabel: null,
          deprecatedValue: sort,
        },
      },
    },
  };
}

export function setFilter(field, rawValue) {
  return {
    type: SET_FILTER,
    field,
    rawValue,
    meta: {
      analytics: {
        type: "filter_used",
        properties: {
          label: field,
          value: JSON.stringify(rawValue),
          deprecatedName: `select-filter/${field}`,
          deprecatedLabel: field,
          deprecatedValue: JSON.stringify(rawValue),
        },
      },
    },
  };
}

export function resetFilter() {
  return { type: RESET_FILTER };
}

export function refreshFilters(filters) {
  return {
    type: REFRESH_FILTERS,
    filters,
  };
}

export function showExtraPlans() {
  return { type: SHOW_EXTRA_PLANS };
}

export function hideExtraPlans() {
  return { type: HIDE_EXTRA_PLANS };
}

export function updateRecommendedPlans(payload) {
  return { type: UPDATE_RECOMMENDED_PLANS, payload };
}

export function refreshQuote() {
  return { type: REFRESH_QUOTE };
}

export const SET_LIMITED_VALUE_PLANS_FILTER = "quote_page/SET_LIMITED_VALUE_PLANS_FILTER";

export function setLimitedValuePlansFilter(field, rawValue) {
  return {
    type: SET_LIMITED_VALUE_PLANS_FILTER,
    field,
    rawValue,
    meta: {
      analytics: {
        type: "filter_used",
        properties: {
          label: `limitedValuePlans-${field}`,
          value: JSON.stringify(rawValue),
        },
      },
    },
  };
}

export const RESET_LIMITED_VALUE_PLANS_FILTER = "quote_page/RESET_LIMITED_VALUE_PLANS_FILTER";

export function resetLimitedValuePlansFilter() {
  return { type: RESET_LIMITED_VALUE_PLANS_FILTER };
}
